import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const KEYS = ["healthcare", "industry", "franchise", "public", "energy", "telecom"] as const;

export const Sectors = () => {
  const { t } = useTranslation();
  return (
    <section id="sectors" className="bg-background py-24 md:py-32 border-t border-border">
      <div className="container-x">
        <div className="max-w-3xl mb-16">
          <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-6">
            {t("sectors.eyebrow")}
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight text-foreground">
            {t("sectors.title")}
          </h2>
          <p className="mt-8 text-base text-muted-foreground leading-relaxed">
            {t("sectors.intro")}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {KEYS.map((k, i) => (
            <Link
              key={k}
              to={`/sectors/${k}`}
              className="group glass glass-shimmer rounded-2xl p-8 transition-all duration-500 min-h-[240px] flex flex-col"
            >
              <span className="text-xs text-muted-foreground tabular-nums">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="font-display mt-6 text-2xl font-medium text-foreground">
                {t(`sectors.items.${k}.name`)}
              </h3>
              <p className="mt-4 text-sm text-muted-foreground leading-relaxed">
                {t(`sectors.items.${k}.desc`)}
              </p>
              <span className="mt-auto pt-6 text-foreground text-sm group-hover:translate-x-1 transition-transform">
                →
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
